import api from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { IAddEditVehicleRequestBody } from 'interfaces/vehicle-interface';
import { IAddClientUserRequest } from 'components/sidemodal/add-user';

interface IDMSData {
  userDetail: {
    name?: string;
    surname?: string;
    phone_number?: string;
    birth_date?: string;
    address: {
      address1?: string;
      address2?: string;
      city?: string;
      country?: string;
      province?: string;
      region?: string;
      state?: string;
      zipcode?: string;
    };
    email?: string;
  };
  vehicleDetail: {
    brandDetail: {
      id: string;
      name: string;
    };
    doors: string;
    engineDetail: {
      id: string;
      name: string;
    };
    is_used: boolean;
    km: number;
    // modelDetail: {
    //   id: string;
    //   name: string;
    // };
    modelDetail: string;
    places: string;
    purchase_date: string;
    registration_date: string;
    fuel_type: string;
    version?: string;
    transmission?: string;
  };
}

interface IPaymentStateType {
  dmsData: IDMSData | null;
  dmsProviders: string[];
}

const initialState: IPaymentStateType = { dmsData: null, dmsProviders: [] };

const DMSSlice = createSlice({
  name: 'DMS',
  initialState: initialState,
  reducers: {
    setDMSDeatils: (state, { payload }: { payload: IDMSData | null }) => {
      state.dmsData = payload;
    },
    setDMSProvider: (state, { payload }: { payload: string[] }) => {
      state.dmsProviders = payload;
    },
  },
});

export const getDMSData =
  (payload: { vin: string; request: { dms_provider_id: string } }) =>
  async (dispatch: Dispatch) => {
    try {
      const { vin, request } = payload;
      const { data: responseData } = await api.post(`/admin/dms/fetch/${vin}`, request);
      dispatch(setDMSDeatils(responseData?.data?.vehicleJson));
      return Promise.resolve(responseData?.data?.vehicleJson);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const getDMSProviders = () => async (dispatch: Dispatch) => {
  try {
    const { data: responseData } = await api.get('/admin/dms/dmsProviders');
    dispatch(setDMSProvider(responseData?.data));
    return Promise.resolve(responseData?.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
export const addDMSVehicle =
  (payload: {
    request: { vehicleDetail: IAddEditVehicleRequestBody; userDetail: IAddClientUserRequest };
  }) =>
  async (dispatch: Dispatch) => {
    try {
      const { request } = payload;
      const { data: responseData } = await api.post('/admin/dms/add', request);
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const { setDMSDeatils, setDMSProvider } = DMSSlice.actions;
export default DMSSlice.reducer;
